
export function NotFoundView({ navigate }: { navigate: (to: string) => void }) {
  return <section className="state-page" data-material-state="error"><img src="/brand/call-sheet-scene.svg" alt="" /><p className="eyebrow">경로를 찾지 못했어요</p><h1>이 작업표 경로는 없어요.</h1><p>저장된 프로젝트는 지워지지 않았습니다. 홈에서 진행 중인 캐릭터를 다시 열 수 있어요.</p><button className="button primary" onClick={() => navigate("/")}>프로젝트 홈으로</button></section>;
}

